
let Errors = [];
function isPasswordStrongInternal(password) {
    if (!password || password.length < 8) return false;
    return (
        /[A-Z]/.test(password) &&
        /[a-z]/.test(password) &&
        /\d/.test(password) &&
        /[^A-Za-z0-9]/.test(password)
    );
}

export const Validator = {
    isPasswordStrong: function (password) {
        return isPasswordStrongInternal(password);
    },
    validateEmail: function (email) {
        const validate = String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );

        if (!validate) Errors.push("Incorrect Email")
    },
    validatePassword: function (password, passwordType) {
        if (password.length === 0) {
            Errors.push(`Please enter your ${passwordType ?? 'password'}`)
            return;
        }
        if (password.length < 8) {
            Errors.push(`${passwordType ?? "password"} Length Should Be > 8`)
            return;
        }
    },
    /** Sign-in only: required field, no minimum length (weak/short passwords are handled by policy redirect). */
    validatePasswordNotEmpty: function (password, passwordType) {
        if (!password || password.length === 0) {
            Errors.push(`Please enter your ${passwordType ?? "password"}`);
        }
    },
    validateStrongPassword: function (password, passwordType) {
        if (!password || password.length === 0) return;
        if (password.length < 8) return;
        if (!isPasswordStrongInternal(password)) {
            const label = passwordType ?? "Password";
            Errors.push(
                `${label} must be at least 8 characters and include uppercase and lowercase letters, a number, and a special character`
            );
        }
    },
    validateConfirmPassword: function (password, confirmPassword) {
        if (password !== confirmPassword) {
            Errors.push("Password Not Equal To Confirm Password")
        }
    },
    validateIfTwoObjectsEqual: function (obj1, obj2) {
        return JSON.stringify(obj1) === JSON.stringify(obj2)
    },
    validateLength: function (value, length, fieldName) {
        if (value.length !== length) {
            Errors.push(`${fieldName} Is Incorrect`)
        }
    },
    validateIfHasError: function (toaster) {
        if (Errors.length > 0) {
            toaster(Errors[0], "Error", "danger");
            Errors.length = 0;
            return true;
        }

        return false;
    }
}